import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { BrandEnum, StepStatusEnum } from 'src/app/core/dtos/enum';
import { Step } from 'src/app/core/dtos/step';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';

@Component({
  selector: 'app-step-progress',
  templateUrl: './step-progress.component.html',
  styleUrls: ['./step-progress.component.scss']
})
export class StepProgressComponent implements OnInit {
  @Input() steps: Step[] = [];

  StepStatusEnum = StepStatusEnum;
  brandId: BrandEnum;

  constructor(
    private configHelper: ConfigHelper,
    private router: Router,
  ) {
    this.brandId = this.configHelper.getBrandId();
  }

  ngOnInit() {
  }

  redirectPreviousStep(step: Step) {
    if (step.status === StepStatusEnum.Completed) {
      this.router.navigate([step.url]);
    }
  }

  public get BrandEnum() {
    return BrandEnum;
  }

}

